import { FC } from 'react';
import { FormattedMessage, useIntl } from 'dibs-react-intl';
import { LOCALE_US } from 'dibs-intl/exports/locales';

import styles from './PdpSharedBuyerProtection.scss';

export const PdpSharedBuyerProtectionBox: FC = () => {
    const { locale } = useIntl();

    return (
        <div className={styles.wrapper} data-tn="buyer-protection-wrrapper">
            {locale !== LOCALE_US && (
                <div className={styles.copy}>
                    <div className={styles.message}>
                        <FormattedMessage
                            id="PdpSharedBuyerProtectionBox.translation.message"
                            defaultMessage="Parts of this page have been automatically translated. 1stDibs cannot guarantee the accuracy of translations. English is the default language of this website."
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
